import tw, { styled } from 'twin.macro';

const IconButton = styled.div((props: { disabled?: boolean; squared?: boolean }) => [
  tw`text-black flex items-center p-2 rounded duration-200 cursor-pointer hover:(bg-primary-300 bg-opacity-25)`,
  props.disabled && tw`opacity-50 hover:(cursor-default bg-opacity-0)`,
]);

export default IconButton;
